import {
  submitMerge,
  submitEventMerge,
  trackOnNextPageImpression,
  submitMove,
  submitEvent
} from '@otto-ec/tracking-bct';

const emitAddToBasketEvent = (payload) =>
  o_global.eventQBus.emit('ft1.order-core.addToBasket', payload);

const emitAddBundleToBasketEvent = (payload) =>
  o_global.eventQBus.emit('ft1.order-core.addToBasketRequest', payload);

const emitViewEvent = (payload, eventMergeId = null) => {
  if (![null, undefined, ''].includes(eventMergeId)) {
    const event = {
      name: 'change',
      features: payload
    };
    submitEventMerge(eventMergeId, {}, event);
  } else {
    submitMerge({}, payload);
  }
};

const emitClickEvent = (
  moveActionPayload,
  onNextPageImpressionPayload,
  additionalTrackingLabels
) => {
  trackOnNextPageImpression(onNextPageImpressionPayload);

  submitMove(additionalTrackingLabels, moveActionPayload);
};

const emitScrollEvent = (scrollPayload, additionalTrackingLabels) => {
  submitEvent(additionalTrackingLabels, scrollPayload);
};

const emitOpenEvent = (openPayload, additionalTrackingLabels) => {
  submitEvent(additionalTrackingLabels, openPayload);
};

const emitCloseEvent = (closePayload, additionalTrackingLabels) => {
  submitEvent(additionalTrackingLabels, closePayload);
};

const emitCheckBoxEvent = (checkBoxPayload, additionalTrackingLabels) => {
  submitEvent(additionalTrackingLabels, checkBoxPayload);
};

const emitHypotheticalEvent = (payload) => {
  submitMerge(payload);
};

export {
  emitAddToBasketEvent,
  emitAddBundleToBasketEvent,
  emitViewEvent,
  emitClickEvent,
  emitScrollEvent,
  emitOpenEvent,
  emitCloseEvent,
  emitCheckBoxEvent,
  emitHypotheticalEvent
};
